<div class="offcanvas-header">
  <button type="button" class="btn-close link" aria-label="Close" (click)="dismiss(null)"></button>
</div>
@if (withBlog || withServices) {
  <div class="offcanvas-body">
    @if (withBlog) {
      <a type="button" class="nav-link link title" title="Blog" href="/{{routes.BLOG}}">
        <span>Blog</span>
      </a>
    }
    @if (withServices) {
      @for (s of sections; track s) {
        <a type="button" class="nav-link link title" title="{{s.title}}"
           (click)="dismiss(s)" tabindex="0">
          <span>{{ s.title }}</span>
        </a>
      }
    }
  </div>
}
<div class="offcanvas-body">
  <a type="button" class="nav-link link title" title="Telefon" href="tel:{{contact.PHONE_NUMBER}}">
    <div class="row">
      <div class="col-1 text-end">
          <i>
            <fa-icon [icon]="faPhone"></fa-icon>
          </i>
      </div>
      <div class="col-11">
        <span>{{ contact.PHONE_NUMBER_TEXT }}</span>
      </div>
    </div>
  </a>
  <a class="nav-link link title" title="E-mail" href="mailto:{{contact.EMAIL}}">
    <div class="row">
      <div class="col-1 text-end">
          <i>
            <fa-icon [icon]="faAt"></fa-icon>
          </i>
      </div>
      <div class="col-11">
        <span>{{ contact.EMAIL }}</span>
      </div>
    </div>
  </a>
  <a type="button" class="nav-link link title" rel="noopener external" title="Adres" href="{{address.GOOGLE_MAPS_URL}}"
     target="_blank">
    <div class="row">
      <div class="col-1 text-end">
          <i>
            <fa-icon [icon]="faMapLocationDot"></fa-icon>
          </i>
      </div>
      <div class="col-11">
        <span>{{ address.ADDRESS_LONG_TEXT }}</span>
      </div>
    </div>
  </a>
  <div class="row">
    <div class="col-2">
      <a class="nav-link link social" rel="noopener external" title="Instagram" href="{{social.INSTAGRAM_URL}}"
         target="_blank">
          <i>
            <fa-icon [icon]="faInstagram"></fa-icon>
          </i>
      </a>
    </div>
    <div class="col-2">
      <a class="nav-link link social" rel="noopener external" title="Facebook" href="{{social.FACEBOOK_URL}}"
         target="_blank">
          <i>
            <fa-icon [icon]="faFacebookSquare"></fa-icon>
          </i>
      </a>
    </div>
  </div>
</div>
